import { mergeStyleSets } from '@fluentui/react';

export const useStyles = () => mergeStyleSets({
  controls: {
    display: 'grid',
    gridTemplateColumns: 'max-content 1fr',
    alignItems: 'center',
    columnGap: '8px',
    rowGap: '4px',
  },
  errorMessage: {
    color: '#a4262c',
  }
})
